export default __webpack_public_path__ + "locales/bg/SharingPanel.json?hash=50c65402444059f0373fad86b939c58c";